import { WorkspaceDto } from '@mark43/cad-api';
import { useLocation } from 'react-router-dom';
import { useCallback, useRef } from 'react';
import { useApplicationType } from '../common/hooks/use-application-type';
import { electronBridge } from '../electron-bridge/electron-bridge';
import { EVENTS_WINDOW_PATH, MAP_WINDOW_PATH } from '../router/constants';
import { useSensorsEnabled } from '../sensors/use-sensors-enabled';

export function useGetWorkspaceWindowIdForLocation() {
    const { isCad } = useApplicationType();
    /*
     * Read through a ref: the workspace store keeps the callback it was constructed with, so a
     * closed-over value would stay whatever it was on the first render.
     */
    const sensorsEnabled = useSensorsEnabled();
    const sensorsEnabledRef = useRef(sensorsEnabled);
    sensorsEnabledRef.current = sensorsEnabled;
    return useCallback(
        (location: ReturnType<typeof useLocation>, workspace: WorkspaceDto) => {
            if (isCad) {
                if (electronBridge) {
                    return electronBridge.args['--workspace-window-id'];
                }
                if (location.pathname === EVENTS_WINDOW_PATH) {
                    const eventV2WorkspaceWindow = workspace.workspaceWindows.find(
                        (workspaceWindow) => workspaceWindow.windowType === 'EVENT_V2'
                    )!;
                    return eventV2WorkspaceWindow.id;
                } else if (location.pathname === MAP_WINDOW_PATH && sensorsEnabledRef.current) {
                    // The map's own window holds the sensor panels. With sensors off, web `/map`
                    // shares the queues window as it always has.
                    const mapV2WorkspaceWindow = workspace.workspaceWindows.find(
                        (workspaceWindow) => workspaceWindow.windowType === 'MAP_V2'
                    )!;
                    return mapV2WorkspaceWindow.id;
                }
                const queueV2WorkspaceWindow = workspace.workspaceWindows.find(
                    (workspaceWindow) => workspaceWindow.windowType === 'QUEUE_V2'
                )!;
                return queueV2WorkspaceWindow.id;
            } else {
                throw new Error('First Responder does not have an active workspace window id');
            }
        },
        [isCad]
    );
}
